

exports.__esModule = true;
exports.filterAll = exports.findAll = exports.tabbable = exports.focusable = exports.visible = exports.KEYS = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var KEYS = {
    TAB: 0x09,
    ENTER: 0x0D,
    ESC: 0x1B,
    SPACE: 0x20,
    LEFT: 0x25,
    UP: 0x26,
    RIGHT: 0x27,
    DOWN: 0x28
};

function visible(element) {
    return _jquery2['default'].expr.filters.visible(element) && !(0, _jquery2['default'])(element).parents().addBack().filter(function () {
        return _jquery2['default'].css(this, 'visibility') === 'hidden';
    }).length;
}

// ripped from http://stackoverflow.com/a/7668761
/* istanbul ignore next */
function focusable(element) {
    var nodeName = element.nodeName.toLowerCase();
    var isTabIndexNotNaN = !isNaN(_jquery2['default'].attr(element, 'tabindex'));
    var map;
    var mapName;
    var img;

    if (nodeName === 'area') {
        map = element.parentNode;
        mapName = map.name;
        if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
            return false;
        }
        img = (0, _jquery2['default'])('img[usemap=#' + mapName + ']')[0];
        return !!img && visible(img);
    }
    return (/^(input|select|textarea|button|object)$/.test(nodeName) ? // eslint-disable-line no-nested-ternary
    !element.disabled : nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) &&
    // the element and all of its ancestors must be visible
    visible(element);
}

/* istanbul ignore next */
function tabbable(element) {
    var tabIndex = _jquery2['default'].attr(element, 'tabindex');
    var isTabIndexNaN = isNaN(tabIndex);

    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}

function filterAll(elements, filterFn) {
    return (0, _jquery2['default'])(elements).filter(function () {
        return filterFn(this);
    });
}

function findAll(container, filterFn) {
    return filterAll((0, _jquery2['default'])(container).find('*'), filterFn);
}

exports.KEYS = KEYS;
exports.visible = visible;
exports.focusable = focusable;
exports.tabbable = tabbable;
exports.findAll = findAll;
exports.filterAll = filterAll;


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-ui-components/src/accessibility/ui.js
 ** module id = 201
 ** module chunks = 1
 **/